export default __webpack_public_path__ + "1.17.16/static/media/LibreDataShare_Hebrew.9abfb84b.svg";